<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Investors Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/investors/contracts'"
            >Contracts</router-link
          >
        </li>
      </ol>
    </div>
    <div
      style="display: flex; justify-content: center; margin-top: 60px"
      class="col-12"
    >
      <span
        class="col-1"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          color: gray;
        "
      >
        <i
          class="fa fa-filter"
          style="font-size: 15px; color: #8cc63f; margin-right: 5px"
        ></i>
        Filter
      </span>
      <span class="col-3" style="display: flex">
        <date-range-picker
          ref="picker"
          :locale-data="{
            firstDay: 1,
            format: 'dd-mm-yyyy',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
          }"
          :timePicker="false"
          :showDropdowns="true"
          :autoApply="true"
          v-model="dateRange"
          @update="filter()"
          :linkedCalendars="true"
          style="width: 100%; background-color: #fafaf7 !important"
        >
        </date-range-picker>
        <button
          style="font-size: 12px; height: 35px; margin-left: 5px"
          type="button"
          class="btn btn-info"
          @click="clearDateRage()"
        >
          Clear
        </button>
      </span>
      <!-- <span class="col-1">

      </span> -->
      <!-- <span class="col-4">
        <select
          class="custom-select"
          v-model="contract_id"
          @change="filter()"
          :showClearButton="true"
        >
          <option v-if="!contract_id" :value="null" disabled selected>
            Select Contract ID
          </option>
          <option v-else :value="null" selected>Clear Selection</option>
          <option
            v-for="contract in contractsList"
            :key="contract.code"
            :value="contract.id"
          >
            {{ contract.code }}
          </option>
        </select>
      </span> -->
      <span class="col-3">
        <multiselect
          v-model="selected_investors"
          :options="investors"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Investors"
          label="code"
          :show-labels="false"
          track-by="id"
          @close="filter()"
        >
          <template slot="selection" slot-scope="{ values, isOpen }"
            ><span
              class="multiselect__single"
              v-if="values.length &amp;&amp; !isOpen"
              >{{ values.length }} investors selected</span
            ></template
          >
        </multiselect>
      </span>
      <span class="col-3">
        <multiselect
          v-model="selected_plans"
          :options="plans"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Plan"
          :custom-label="customPlanLabel"
          label="code"
          :show-labels="false"
          track-by="id"
          @close="filter()"
        >
          <template slot="selection" slot-scope="{ values, isOpen }"
            ><span
              class="multiselect__single"
              v-if="values.length &amp;&amp; !isOpen"
              >{{ values.length }} plans selected</span
            ></template
          >
        </multiselect>
      </span>
      <span class="col-2">
        <multiselect
          v-model="selected_status"
          :options="statusList"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Status"
          label="name"
          :show-labels="false"
          track-by="id"
          @close="filter()"
        >
          <template slot="selection" slot-scope="{ values, isOpen }"
            ><span
              class="multiselect__single"
              v-if="values.length &amp;&amp; !isOpen"
              >{{ values.length }} status selected</span
            ></template
          >
        </multiselect>
      </span>
      <!-- <span class="col-4">
        <select
          class="custom-select"
          v-model="investor_id"
          @change="filter()"
          :showClearButton="true"
        >
          <option v-if="!investor_id" :value="null" disabled selected>
            Select Investor ID
          </option>
          <option v-else :value="null" selected>Clear Selection</option>
          <option
            v-for="investor in investors"
            :key="investor.code"
            :value="investor.id"
          >
            {{ investor.code }}
          </option>
        </select>
      </span> -->
      <!-- <span class="col-3">
        <select
          class="custom-select"
          v-model="status"
          @change="filter()"
          :showClearButton="true"
        >
          <option v-if="!status" :value="null" disabled selected>
            Select a Status
          </option>
          <option v-else :value="null" selected>Clear Selection</option>
          <option
            v-for="status in statusList"
            :key="status.name"
            :value="status.id"
          >
            {{ status.name }}
          </option>
        </select>
      </span> -->
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <div
        style="display: flex; justify-content: center; cursor: pointer"
        @click="toggleCreateContractModal()"
      >
        <div>
          <i
            class="fa fa-plus-circle"
            style="font-size: 90px; color: #8cc63f; margin-right: 5px"
          ></i>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            flex-direction: column;
            margin: 0;
            justify-content: center;
            margin-left: 10px;
          "
        >
          <p
            style="
              margin: 0px;
              font-size: 40px;
              margin-bottom: 5px;
              color: #8cc63f;
            "
          >
            ADD
          </p>
          <p style="margin: 0; color: #8cc63f; font-size: 14px">new contract</p>
        </div>
      </div>
    </div>
    <div
      style="
        margin-top: 50px;
        display: flex;
        justify-content: end;
        padding: 0 60px;
      "
    >
      <input
        id="showContractValue"
        v-model="showContractValue"
        type="checkbox"
        style="height: 20px; width: 20px"
      />
      <span style="margin-left: 5px" for="showContractValue">Show Hidden</span>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 10px">
      <md-card
        class="md-card-stats"
        style="
          background-color: white;
          max-width: 90%;
          border-radius: 15px;
          padding: 40px;
          margin: 0;
        "
      >
        <spinner v-if="searchingContracts" />

        <vue-good-table
          v-else
          :columns="contractColumns"
          :rows="contracts"
          max-height="450px"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'code', type: 'asc' },
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'code'">
              <router-link
                style="color: black !important; font-weight: bold"
                :to="
                  '/' +
                  authUser.userable_type +
                  '/investor/' +
                  props.row.investor_id +
                  '/contract/update/' +
                  props.row.id
                "
              >
                {{ props.formattedRow[props.column.field] }}</router-link
              >
            </span>
            <span v-else-if="props.column.field == 'investor_code'">
              <router-link
                style="color: black !important; font-weight: bold"
                :to="
                  '/' +
                  authUser.userable_type +
                  '/investor/' +
                  props.row.investor_code +
                  '/' +
                  props.row.investor_id
                "
              >
                {{ props.formattedRow[props.column.field] }}</router-link
              >
            </span>
            <span v-else-if="props.column.label == 'Value'">
              {{
                showContractValue
                  ? fixNumberView(props.row.invested_principal) +
                    " " +
                    props.row.currency_code
                  : "*******"
              }}
            </span>
          </template></vue-good-table
        >
        <!-- <table style="text-align: center">
          <thead>
            <tr>
              <th>Contract ID</th>
              <th>Investor ID</th>
              <th>Status</th>
              <th>Plan</th>
              <th style="cursor: pointer" @click="toggleShowContractValue()">
                Value
              </th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Length</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(contract, key) in contracts" :key="key">
              <td>{{ contract.code }}</td>
              <td>{{ contract.investor_code }}</td>
              <td>
                {{
                  statusList.find((status) => {
                    return status.id == contract.status;
                  }).name
                }}
              </td>
              <td>{{ contract.plan_name }}</td>
              <td v-if="showContractValue">
                {{ fixNumberView(contract.invested_principal) }}
                {{ contract.currency_code }}
              </td>
              <td v-else>******</td>
              <td>{{ contract.start_date }}</td>
              <td>{{ contract.maturity_date }}</td>
              <td>
                {{
                  getContractDuration(
                    contract.start_date,
                    contract.maturity_date
                  )
                }}
              </td>
              <td>
                <i
                  style="cursor: pointer"
                  @click="redirectToInvestor(contract)"
                  class="fa fa-eye"
                ></i>
                <i
                  style="cursor: pointer"
                  @click="redirectToUpdateContract(contract)"
                  class="fa fa-edit"
                ></i>
              </td>
            </tr>
          </tbody>
        </table> -->
      </md-card>
    </div>
    <contract-modal
      :active="showContractModal"
      contractType="InvestorContract"
      @closeRequest="toggleCreateContractModal()"
    />
  </div>
</template><script>
import ContractModal from "./components/modals/contractModal.vue";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import InvestorContractsFilter from "../../filters/InvestorContractsFilter";
import InvestorsFilter from "../../filters/InvestorsFilter";
import PlansFilter from "../../filters/PlansFilter";
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import Multiselect from "vue-multiselect";
import Spinner from "vue-simple-spinner";

export default {
  name: "contracts",
  data() {
    return {
      selectedContractId: null,
      showContractModal: false,
      showContractValue: false,
      contract_id: null,
      keyword: null,
      status: null,
      statusList: [
        { id: "active", name: "Active" },
        { id: "inactive", name: "InActive" },
        { id: "notstarted", name: "Not Started" },
        { id: "closed", name: "Closed" },
      ],
      contractsList: [],
      selected_investors: [],
      selected_status: [],
      selected_plans: [],
      dateRange: {
        startDate: null,
        endDate: null,
      },
      contractColumns: [
        {
          label: "Contract ID	",
          field: "code",
        },
        {
          label: "Investor ID",
          field: "investor_code",
        },
        {
          label: "Status",
          field: this.getContractStatus,
        },
        {
          label: "Plan",
          field: "plan_name",
        },
        {
          label: "Value",
          field: "invested_principal",
        },
        {
          label: "Start Date",
          field: "start_date",
        },
        {
          label: "End Date",
          field: "maturity_date",
        },
        {
          label: "Length	",
          field: this.getContractDuration,
        },
        // {
        //   label: "Actions",
        //   field: '',
        // },
      ],
    };
  },

  components: {
    ContractModal,
    Multiselect,
    DateRangePicker,
    Spinner,
  },
  created: function () {
    var contractFilter = InvestorContractsFilter();
    this.$store
      .dispatch("searchInvestorContracts", {
        filter: contractFilter,
        resultMode: "default",
      })
      .then(() => {
        this.contractsList = this.contracts;
      });
    var investorsFilter = InvestorsFilter();
    this.$store.dispatch("searchInvestors", {
      filter: investorsFilter,
      resultMode: "default",
    });
    var plansFilter = PlansFilter();
    this.$store.dispatch("searchPlans", {
      filter: plansFilter,
      resultMode: "default",
    });
  },
  computed: {
    activeContract() {
      // can be not array when paginated
      if (this.contracts && Array.isArray(this.contracts)) {
        return this.contracts.find((c) => c.id == this.selectedContractId);
      }
    },
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      contracts: (state) =>
        state.contractStore.investorContractSearch.investorContracts,
      searchingContracts: (state) =>
        state.contractStore.investorContractSearch.searchingInvestorContracts,
      investors: (state) => state.investorStore.investorSearch.investors,
      plans: (state) => state.planStore.planSearch.plans,
      createContractStatus: (state) =>
        state.contractStore.investorContractCreate.createInvestorContractStatus,
      updateContractStatus: (state) =>
        state.contractStore.investorContractUpdate.updateInvestorContractStatus,
      deleteContractStatus: (state) =>
        state.contractStore.investorContractDelete.deleteInvestorContractStatus,
    }),
  },
  methods: {
    init() {
      this.selectedContractId = null;
      this.showContractModal = false;
      this.$store.dispatch("searchInvestorContracts");
    },
    customPlanLabel(plan) {
      return plan.code + " (" + plan.name + ")";
    },
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    clearDateRage() {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
      this.filter();
    },
    toggleShowContractValue() {
      this.showContractValue = !this.showContractValue;
    },
    redirectToInvestor(contract) {
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/investor/" +
          contract.investor_code +
          "/" +
          contract.investor_id
      );
    },
    redirectToUpdateContract(contract) {
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/investor/" +
          contract.investor_id +
          "/contract/update/" +
          contract.id
      );
    },
    getContractStatus(contract) {
      let status = this.statusList.find((status) => {
        return status.id == contract.status;
      }).name;
      return status;
    },
    getContractDuration(contract) {
      var start = contract.start_date;
      var end = contract.maturity_date;
      let duration = moment.duration(moment(start).diff(moment(end)));
      let durationString = "";
      if (duration.years() / -1) {
        durationString += duration.years() / -1 + " Years, ";
      }
      if (duration.months() / -1) {
        durationString += duration.months() / -1 + " Months, ";
      }
      if (duration.days() / -1) {
        durationString += duration.days() / -1 + " Days, ";
      }
      durationString = durationString.substring(0, durationString.length - 2);
      return durationString;
    },
    filter() {
      var contractsFilter = InvestorContractsFilter();
      // contractsFilter.status = this.status;
      // if (this.contract_id) {
      //   contractsFilter.ids = [this.contract_id];
      // }
      if (this.selected_investors) {
        this.selected_investors.forEach((investor) => {
          if (!contractsFilter.investor_ids.includes(investor.id)) {
            contractsFilter.investor_ids.push(investor.id);
          }
        });
      }
      if (this.selected_plans) {
        this.selected_plans.forEach((plan) => {
          if (!contractsFilter.plan_ids.includes(plan.id)) {
            contractsFilter.plan_ids.push(plan.id);
          }
        });
      }
      if (this.selected_status) {
        this.selected_status.forEach((status) => {
          if (!contractsFilter.status.includes(status.id)) {
            contractsFilter.status.push(status.id);
          }
        });
      }
      // if (this.investor_id) {
      //   contractsFilter.investor_ids = [this.investor_id];
      // }
      if (this.dateRange.startDate != null && this.dateRange.endDate != null) {
        let start_date = moment(this.dateRange.startDate).format("YYYY-MM-DD");
        let end_date = moment(this.dateRange.endDate).format("YYYY-MM-DD");
        let date_range = { startDate: start_date, endDate: end_date };
        contractsFilter.dateRange = date_range;
      }
      this.$store.dispatch("searchInvestorContracts", {
        filter: contractsFilter,
        resultMode: "default",
      });
    },
    toggleCreateContractModal() {
      this.showContractModal = !this.showContractModal;
    },
    createContract(contract) {
      this.$store.dispatch("createInvestorContract", contract);
    },
    updateContract(contract) {
      this.$store.dispatch("updateContract", contract);
    },
    deleteContract(id) {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this contract?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.$store.dispatch("deleteContract", id);
        }
      });
    },
  },
  watch: {
    createContractStatus() {
      if (this.createContractStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Contract has been created successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.createContractStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Contract creation has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    updateContractStatus() {
      if (this.updateContractStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Contract has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.updateContractStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Contract update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    deleteContractStatus() {
      if (this.deleteContractStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Contract has been deleted successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.deleteContractStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Contract delete has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
 <style>
.multiselect__option--highlight,
.multiselect__option--highlight:after {
  background: #00a5e3;
}
.multiselect__tags {
  background-color: #fafaf7;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 5px 20px 0 8px;
  font-size: 16px;
}
.multiselect__input,
.multiselect__single {
  background: none;
  font-size: 14px;
  margin: 0;
  margin-top: 5px;
}
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
  background-color: rgb(250, 250, 247) !important;
}
.custom-select {
  background-color: #fafaf7;
}
.vgt-table.bordered td,
.vgt-table.bordered th {
  border: hidden !important;
}

.vgt-table.bordered td,
.vgt-table.bordered th {
  border: hidden !important;
  background: none;
}

.vgt-inner-wrap {
  box-shadow: none !important;
}
.vgt-left-align {
  text-align: center;
}
.vgt-right-align {
  text-align: center;
}
.vgt-table.bordered td,
.vgt-table.bordered th {
  background: #fff;
  color: black;
}

table.vgt-table thead th {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 0;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/investorContracts.vue